<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'studentCourseEqualization_editCourseTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="data-value">
            <label>{{'studentCourseEqualization_lblCourseRSU' | translate}}</label>
            <div>
                {{model.Code}} {{model.Name}}, {{model.Ects}} ECTS
            </div>
        </div>

        <div class="form-field required">
            <label class="form-label">{{'studentCourseEqualization_lblDecision' | translate}}</label>
            <app-select [(ngModel)]="decision"
                        [options]="decisionOptions"
                        [displayProperty]="'Value'"
                        [required]="true"
                        name="decision"
                        (selectionChange)="onDecisionChange()">
            </app-select>
        </div>

        <div class="form-field required" *ngIf="isPartialPass || isNoPass">
            <label class="form-label">{{(isNoPass ? 'studentCourseEqualization_lblJustification' : 'studentCourseEqualization_lblConditions') | translate}}</label>
            <textarea class="form-control" name="decisionComment" rows="5" [(ngModel)]="model.ApprovalComment" required></textarea>
        </div>

        <div class="mb-3" *ngIf="isPartialPass">
            <app-checkbox name="IsEqualizedWithNoGrade" [(ngModel)]="model.IsEqualizedWithNoGrade" (stateChange)="onEqualizeWithNoGrade($event)">
                {{'studentCourseEqualization_lblIsEqualizedWithNoGrade' | translate}}
            </app-checkbox>
        </div>

        <div class="row">
            <div class="col-sm">
                <div class="form-field required">
                    <label class="form-label">{{'studentCourseEqualization_lblAcquireEcts' | translate}}</label>
                    <input class="form-control" [(ngModel)]="model.AcquireEcts" name="acquireEcts" required pattern="^[1-9][0-9]{0,2}(\.[0-9][0-9]?)?$"
                           [disabled]="!isPartialPass" />
                </div>
            </div>

            <div class="col-sm">
                <div class="form-field">
                    <label class="form-label">{{'studentCourseEqualization_lblGrade' | translate}}</label>
                    <app-select [(ngModel)]="grade"
                                [options]="gradeOptions"
                                [displayProperty]="'Value'"
                                name="grade"
                                [disabled]="model.IsEqualizedWithNoGrade || isNoPass"
                                [clear]="false">
                    </app-select>
                </div>
            </div>
        </div>
    </form>

    <app-table [rows]="model.Courses" [columns]="outerColumns" [showTotal]="false" [style]="'plain'">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>
                    <div class="text-top">{{row.Name}}</div>
                    <div class="text-mute" *ngIf="row.University">{{row.University}}</div>
                    <div class="text-mute" *ngIf="row.Programme">{{row.Programme}}</div>
                </td>
                <td>{{row.Ects | number:'1.0-2':'en-US'}}</td>
                <td>{{row.GradeValue}}</td>
                <td>
                    <div *ngFor="let a of row.Attachments" class="attachment-row" [title]="a.FileName">
                        <a *ngIf="a.Id" href="#" (click)="$event.preventDefault(); downloadAttachment(a)">
                            {{util.compactFileName(a.FileName, 20)}}
                        </a>
                        <ng-container *ngIf="!a.Id">{{util.compactFileName(a.FileName, 20)}}</ng-container>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()">{{'dialog_cancel' | translate}}</button>

    <button class="btn btn-primary" type="button" (click)="ok()" [disabled]="!form.valid">
        {{'dialog_ok' | translate}}
    </button>
</div>
